/* eslint-disable no-magic-numbers */
import React from "react";
import { sendCustomGaEvents } from "../../../tracking";
import styles from "./styles.css";

const HeaderWhatsapp = () => {
    const onWhatsappClick = () => {
        sendCustomGaEvents({
            event: "whatsapp_icon_clicked",
            eventCategory: "homepage",
            eventAction: "whatsapp_icon_header"
        });
        const number = 918448690288;
        window.location.href = `https://api.whatsapp.com/send/?phone=${number}&text=Hi+CARS24%2C+I%27m+looking+for+some+assistance%21%21&type=phone_number&app_absent=0 `;
    };

    return (
        <div onClick={onWhatsappClick} styleName={"styles.whatsAppCallIcon"}>
            <svg  width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8707 8.70791C10.6167 8.10495 10.3584 8.18662 10.1659 8.17708C9.98348 8.16859 9.77507 8.16594 9.56613 8.16594C9.35719 8.16594 9.01833 8.24336 8.7309 8.55306C8.44348 8.86276 7.63477 9.61048 7.63477 11.1325C7.63477 12.6544 8.75689 14.1239 8.91333 14.3307C9.0703 14.537 11.1215 17.66 14.2625 18.9995C15.0097 19.3177 15.593 19.5081 16.0475 19.6507C16.7973 19.8862 17.4804 19.8528 18.0202 19.7732C18.6216 19.6847 19.8731 19.025 20.134 18.3032C20.3949 17.5809 20.3949 16.9621 20.3164 16.8332C20.2379 16.7043 20.029 16.6269 19.7161 16.4721C19.4033 16.3172 17.8633 15.569 17.5758 15.4666C17.2884 15.3632 17.08 15.3118 16.8711 15.6215C16.6621 15.9312 16.0623 16.6269 15.8799 16.8337C15.6975 17.04 15.5145 17.066 15.2017 16.9112C14.8888 16.7563 13.8791 16.4302 12.6838 15.3765C11.7526 14.5566 11.1242 13.5443 10.9417 13.2346C10.7593 12.9249 10.9221 12.7578 11.0791 12.6035C11.2201 12.4646 11.392 12.2424 11.5489 12.0615C11.7059 11.8807 11.7579 11.7518 11.8618 11.5456C11.9658 11.3393 11.9138 11.1584 11.8353 11.0036C11.7579 10.8487 11.1316 9.3273 10.8707 8.70791Z" fill="#465166"/>
                <path d="M13.9987 2.33334C7.55552 2.33334 2.33203 7.55682 2.33203 14C2.33203 16.1594 2.9212 18.1809 3.94415 19.9155L2.33203 25.6667L8.31067 24.1855C9.99385 25.1273 11.9326 25.6667 13.9987 25.6667C20.4419 25.6667 25.6654 20.4432 25.6654 14C25.6654 7.55682 20.4419 2.33334 13.9987 2.33334Z" stroke="#465166" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round"/>
            </svg>
        </div>

    );
};

export default HeaderWhatsapp;
